import ShopScreen from './containers/shopScreen'

export {default as ShopScreenLayout} from './components/shopScreenLayout'

export default ShopScreen
